import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Typography } from '@mui/material';

const CustomSelectBox = ({ label, options, Value, setValue }) => {
    return (
        <div>
            <Typography sx={{
                fontFamily: 'Times New Roman',
                fontWeight: '400',
                fontSize: '18px',
                lineHeight: '20.7px',
                color: '#3D3D3D',
                paddingBottom: '10px'
            }}>{label}</Typography>
            <Autocomplete
                disablePortal
                options={options}
                value={Value}
                onChange={(e, newValue) => setValue(newValue)}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                sx={{
                    border: '1px',
                    borderRadius: '5px',
                    borderColor: '#D0D0D0',
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'Times New Roman',
                        fontSize: '17px',
                        height: '45px',
                        '& fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&:hover fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#D0D0D0',
                        },
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#272727",
                    },
                }}
                renderInput={(params) => <TextField {...params} />}
            />
        </div>
    );
};

export default CustomSelectBox;
